import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=608ab778&scoped=true&lang=pug"
import script from "./Page404.vue?vue&type=script&lang=js"
export * from "./Page404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608ab778",
  null
  
)

export default component.exports